import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Collapse from 'react-bootstrap/Collapse';
import { t } from '../../../../i18n';
import { arrowRightPointerIcon } from '../../../assets/index';
import Button from '../../../../components/button/index';
import ProfileCourseCard from '../../profile-course-card/index';
import './styles.scss';

const CoursesSlider = ({
  carouselRef,
  courses,
  cardsPerSlide,
  slidesCollection,
  onSlide,
  onPlayCoursePreview,
  onShowAllCourses,
  showAllCourses,
}) => {
  const [showCarousel, setShowCarousel] = useState(true);

  return (
    <>
      <Carousel
        ref={carouselRef}
        interval={null}
        controls={false}
        indicators={false}
        touch={false}
        wrap={false}
        onSlide={onSlide}
      >
        {showCarousel &&
          slidesCollection?.map((slideCourses, index) => (
            <Carousel.Item key={index}>
              <div className="profile-courses-carousel__slide-wrapper">
                {slideCourses?.map((course, index) => (
                  <ProfileCourseCard key={index} course={course} onPlayCoursePreview={onPlayCoursePreview} />
                ))}
              </div>
            </Carousel.Item>
          ))}
        <Collapse in={showAllCourses} onEntered={() => setShowCarousel(false)} onExit={() => setShowCarousel(true)}>
          <div className="profile-courses-carousel__all-courses-wrapper">
            {courses?.map((course, index) => (
              <ProfileCourseCard key={index} course={course} onPlayCoursePreview={onPlayCoursePreview} />
            ))}
          </div>
        </Collapse>
      </Carousel>
      {courses?.length > cardsPerSlide && (
        <div className="profile-courses-carousel__view-all-button-wrapper">
          <Button
            className="profile-courses-carousel__view-all-button"
            text={
              <span>
                {showAllCourses
                  ? t('DIGITAL_COURSES.COURSES_LIST.VIEW_FEWER_COURSES')
                  : t('DIGITAL_COURSES.COURSES_LIST.VIEW_ALL_COURSES')}
                <img src={arrowRightPointerIcon} alt="arrow-right" />
              </span>
            }
            onClick={onShowAllCourses}
          />
        </div>
      )}
    </>
  );
};

export default CoursesSlider;
